import { useMutation, useQueryClient } from "react-query";

import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getUserOrganizationRolesQueryKey } from "src/api/client-api/userOrganizationRoles/types";

type DeleteUserOrganizationRoles = {
    userId: number;
    organizationId: number;
};

export const useDeleteUserOrganizationRoles = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ userId, organizationId }: DeleteUserOrganizationRoles) => {
            return await loggedInApiCall.delete(`/api/users/${userId}/organizations/${organizationId}/roles`);
        },
        onSuccess: (_data, variables) => {
            queryClient.setQueryData(getUserOrganizationRolesQueryKey(variables.userId, variables.organizationId), {
                roles: [],
            });
            queryClient.invalidateQueries(getUserOrganizationRolesQueryKey(variables.userId, variables.organizationId));
            queryClient.invalidateQueries("allUsers");
        },
    });
};
